module.exports = __webpack_public_path__ + "static/explore_screen-b51d4d12bcd6ba116db362032f9b08f4.png";